import { useContext, useEffect, useState } from "react";

// react-router-dom components
import { Link } from "react-router-dom";

// @mui material components
import Card from "@mui/material/Card";
import Switch from "@mui/material/Switch";

// @mui icons
import FacebookIcon from "@mui/icons-material/Facebook";
import GitHubIcon from "@mui/icons-material/GitHub";
import GoogleIcon from "@mui/icons-material/Google";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

// Authentication layout components
import BasicLayoutLanding from "layouts/authentication/components/BasicLayoutLanding";

// Images
import loginImage from "assets/images/login_image.jpg";
import apiService from "../../services/api-service";
import AuthService from "services/auth-service";
import { AuthContext } from "context";
import { AuthContextSingleton } from "../authContext/authContext";
import { useNavigate } from "react-router-dom";
function Login(props) {
	const authContext = useContext(AuthContext);
	const navigate = useNavigate();
	const [user, setUser] = useState({});
	const [credentialsErros, setCredentialsError] = useState(null);
	const [rememberMe, setRememberMe] = useState(false);

	const [formData, setFormData] = useState({
		email: "",
		password: "",
	});

	const [errors, setErrors] = useState({
		emailError: false,
		passwordError: false,
	});

	const addUserHandler = (newUser) => setUser(newUser);

	const handleSetRememberMe = () => setRememberMe(!rememberMe);

	const changeHandler = (e) => {
		setFormData({
			...formData,
			[e.target.name]: e.target.value,
		});
	};

	const submitHandler = async (e) => {
		// check rememeber me?
		e.preventDefault();

		const mailFormat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;

		if (formData.email.trim().length === 0 || !formData.email.trim().match(mailFormat)) {
			setErrors({ ...errors, emailError: true });
			return;
		}

		if (formData.password.trim().length < 6) {
			setErrors({ ...errors, passwordError: true });
			return;
		}

		const myData = {
			username: formData?.email,
			password: formData?.password,
		};

		try {
			const response = await AuthService.login(myData);
			localStorage.setItem("refresh", response?.refresh);
			authContext.login(response?.access, response?.refresh);
			//AuthContextSingleton(authContext);
		} catch (res) {
			if (res.hasOwnProperty("message")) {
				setCredentialsError(res?.message);
			} else {
				let error = res?.detail;
				if (error) {
					setCredentialsError(error);
				}
			}
		}

		return () => {
			setFormData({
				email: "",
				password: "",
			});

			setErrors({
				emailError: false,
				passwordError: false,
			});
		};
	};

	// useEffect(() => {
	// 	if (authContext.isAuthenticated) {
	// 		navigate("/");
	// 	}
	// }, [authContext.isAuthenticated]);

	return (
		<BasicLayoutLanding image={loginImage}>
			<Card>
				<MDBox variant="gradient" bgColor="info" borderRadius="lg" coloredShadow="info" mx={2} mt={-3} p={2} mb={1} textAlign="center">
					<MDTypography variant="h4" fontWeight="medium" color="white" mt={1}>
						Login
					</MDTypography>
				</MDBox>
				<MDBox pt={4} pb={3} px={3}>
					<MDBox component="form" role="form" method="POST" onSubmit={submitHandler}>
						<MDBox mb={2}>
							<MDInput type="email" label="Email" fullWidth value={formData.email} name="email" onChange={changeHandler} error={errors.emailError} />
						</MDBox>
						<MDBox mb={2}>
							<MDInput type="password" label="Password" fullWidth name="password" value={formData.password} onChange={changeHandler} error={errors.passwordError} />
						</MDBox>
						<MDBox display="flex" alignItems="center" ml={-1}>
							<Switch checked={rememberMe} onChange={handleSetRememberMe} />
							<MDTypography
								variant="button"
								fontWeight="regular"
								color="text"
								onClick={handleSetRememberMe}
								sx={{
									cursor: "pointer",
									userSelect: "none",
									ml: -1,
								}}
							>
								&nbsp;&nbsp;Remember me
							</MDTypography>
						</MDBox>
						<MDBox mt={4} mb={1}>
							<MDButton variant="gradient" color="info" fullWidth type="submit">
								sign in
							</MDButton>
						</MDBox>
						{credentialsErros && (
							<MDTypography variant="caption" color="error" fontWeight="light">
								{credentialsErros}
							</MDTypography>
						)}
						<MDBox mt={3} mb={1} textAlign="center">
							<MDTypography variant="button" color="text">
								Forgot your password? Reset it{" "}
								<MDTypography component={Link} to="/auth/forgot-password" variant="button" color="info" fontWeight="medium" textGradient>
									here
								</MDTypography>
							</MDTypography>
						</MDBox>
					</MDBox>
				</MDBox>
			</Card>
		</BasicLayoutLanding>
	);
}

export default Login;
